import React from 'react';
import { PlusIcon, ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
const faqs = [{
  question: 'How do I know if I have a claim?',
  answer: 'You may have a claim if another person or organisation contributed to an injury that caused medical costs, time away from work or an ongoing loss. The facts, timing and applicable law all matter.'
}, {
  question: 'The insurer wants to settle quickly. What should I do?',
  answer: 'You do not have to accept an early offer before you understand your position. Get advice first so the decision reflects the full effect of your injury, not only what is known today.'
}, {
  question: 'What does no win, no fee mean?',
  answer: 'Legal fees are paid at the end of a successful claim, subject to the written costs agreement. We explain the terms, disbursements and important risks before you decide whether to proceed.'
}, {
  question: 'What do I need before I call?',
  answer: 'Nothing formal. Tell us what happened in your own words. If you have insurer letters, medical records or incident details, they can be reviewed later.'
}, {
  question: 'What time limits apply?',
  answer: 'Time limits vary by claim type and circumstances. Getting advice early helps clarify the deadline that may apply and preserve useful evidence.'
}, {
  question: 'Will my claim go to court?',
  answer: 'Many claims resolve through negotiation. If court action is required to protect your interests, we explain why and what the process involves before that step is taken.'
}, {
  question: 'Can I claim if I was partly at fault?',
  answer: 'You may still be able to claim, although partial fault can affect the outcome. A lawyer can assess how the circumstances and applicable law apply to you.'
}, {
  question: 'What happens after I use the claim calculator?',
  answer: 'A senior injury lawyer reviews your answers and contacts you for a confidential discussion about the likely claim path and realistic next steps.'
}];
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }))
};
export function FAQSection() {
  return <Section id="faq" className="bg-canvas" data-id="element-211" data-mp="382y5pjmppae0">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-212" data-mp="381wrx7eba9sl" />
      <SectionHeading eyebrow="Before you decide" title="The Questions That Usually Hold People Back" intro="Straight answers to the practical concerns people raise before speaking with an injury lawyer." align="center" data-id="element-213" data-mp="3cz6jotp6axjl" />

      <div className="mx-auto mt-8 max-w-3xl space-y-2.5" data-id="element-214" data-mp="3quimlodhfubl">
        {faqs.map(item => <details key={item.question} className="group overflow-hidden rounded-card border border-ink/5 bg-paper shadow-card" data-id="element-215" data-mp="3vssjq4irp4zu">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-body font-semibold text-ink marker:hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal sm:px-6" data-id="element-216" data-mp="1f5ubcsi9nqok">
              {item.question}
              <PlusIcon className="h-5 w-5 shrink-0 text-signal transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-217" data-mp="166yzp0wgdodv" />
            </summary>
            <p className="px-5 pb-5 pr-10 text-[16px] leading-[1.6] text-slate sm:px-6" data-id="element-218" data-mp="1u2v14qgwdbke">
              {item.answer}
            </p>
          </details>)}
      </div>

      <div className="mt-6 text-center" data-id="element-219" data-mp="1p1nuwvuekkfu">
        <a href="/resources/faqs/" className="inline-flex items-center gap-2 text-[16px] font-semibold text-forest hover:text-signal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-220" data-mp="2mjnxeghi4ec4">
          View all frequently asked questions
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="26brhnw1gqs7v" />
        </a>
      </div>
    </Section>;
}